export default "__VITE_ASSET__tm2bhqqV__"